/* eslint-disable no-unused-vars */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// interface Step {
//   success_message: string;
//   goal_message: string;
//   start: number;
//   end: number;
// }

interface UserState {
  isLogin: boolean;
  point: number;
  telegramId: string;
  walletAddress: string;
  myReferralCode: string;
  ids: {
    userId: string;
    settingId: string;
    pointId: string;
  };
  setLogin: (isLogin: boolean) => void;
  increasePoint: (increase?: number) => void;
  setUser: (userId: string, walletAddress: string, referralCode: string) => void;
  setIds: (userId: string, settingId: string, pointId: string) => void;
  setPoint(point: number): void;
  resetUser: () => void;
}

// const steps: Step[] = [
//   {
//     step: 0,
//     success_message: '',
//     goal_message: 'to purchase land!',
//     start: 0,
//     end: 100,
//   },
//   {
//     step: 1,
//     success_message: 'You purchased land!',
//     goal_message: 'to build a house!',
//     start: 100,
//     end: 1000,
//   },
//   {
//     step: 2,
//     success_message: 'You built a house!',
//     goal_message: 'to buy a house!',
//     start: 1000,
//     end: 2000,
//   },
//   {
//     step: 3,
//     success_message: 'You bought a house!',
//     goal_message: 'to rent out a house!',
//     start: 2000,
//     end: 3000,
//   },
//   {
//     step: 4,
//     success_message: 'You can now rent out your house!',
//     goal_message: 'to build a store!',
//     start: 3000,
//     end: 4000,
//   },
//   {
//     step: 5,
//     success_message: 'You built a store!',
//     goal_message: 'to buy a store!',
//     start: 4000,
//     end: 5000,
//   },
//   {
//     step: 6,
//     success_message: 'You bought a store!',
//     goal_message: 'to rent out a store!',
//     start: 5000,
//     end: 6000,
//   },
//   {
//     step: 7,
//     success_message: 'You can now rent out your store!',
//     goal_message: 'to build a multi-use building!',
//     start: 6000,
//     end: 7000,
//   },
//   {
//     step: 8,
//     success_message: 'You built a multi-use building!',
//     goal_message: 'to buy a multi-use building!',
//     start: 7000,
//     end: 8000,
//   },
//   {
//     step: 9,
//     success_message: 'You bought a multi-use building!',
//     goal_message: 'to rent out a multi-use building!',
//     start: 8000,
//     end: 9000,
//   },
// ];

const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      isLogin: false,
      point: 0,
      telegramId: '',
      walletAddress: '',
      myReferralCode: '',
      ids: {
        userId: '',
        settingId: '',
        pointId: '',
      },
      setLogin: (isLogin: boolean) => set({ isLogin }),
      setUser: (id, walletAddress, referralCode) =>
        set({ telegramId: id, walletAddress, myReferralCode: referralCode }),

      setIds: (userId, settingId, pointId) => {
        set({
          ids: {
            userId: userId,
            settingId: settingId,
            pointId: pointId,
          },
        });
      },
      increasePoint: (
        increase = 10, // 10으로 해야 순차적으로 올라가는 애니메이션을 사용 할 수 있다.
      ) =>
        set((state) => ({
          point: state.point + increase,
        })),
      setPoint: (point: number) => set({ point }),
      resetUser: () =>
        set({
          isLogin: false,
          point: 0,
          telegramId: '',
          walletAddress: '',
          myReferralCode: '',
          ids: {
            userId: '',
            settingId: '',
            pointId: '',
          },
        }),
    }),
    {
      name: 'user-storage', // localStorage에 저장될 Key 이름
      partialize: (state) => ({
        // 로컬 스토리지에 저장할 항목만 선택 가능
        isLogin: state.isLogin,
        point: state.point,
        telegramId: state.telegramId,
        walletAddress: state.walletAddress,
        myReferralCode: state.myReferralCode,
        ids: state.ids,
      }),
    },
  ),
);

export default useUserStore;

// const useUserStore = create<UserState>((set) => ({
//   isLogin: false,
//   point: 0,
//   telegramId: 'fnsle92',
//   walletAddress: '0x204asdfsdafasdfasdf937',
//   myReferralCode: 'jfhksl',
//   steps,
//   userId: '',
//   settingId: '',
//   pointId: '',
//   setUser: (userId: string, walletAddress: string, referralCode: string) =>
//     set({ telegramId: userId, walletAddress, myReferralCode: referralCode }),
//   setIds: (userId: string, settingId: string, pointId: string) => {
//     set({ userId, settingId, pointId });
//   },
//   // setSetp: (step: number) => set({ steps: step }),
//   increasePoint: (increase: number = 10) => {
//     set((state) => ({
//       point: state.point + increase,
//     }));
//   },
// }));

// export default useUserStore;
